import { Component } from '@angular/core';

@Component({
  standalone: false,
  template: `
    <header class="row expanded ml-6">
      <div class="small-12 medium-12 large-12 columns">
        <h1>Access Denied</h1>
      </div>
    </header>
  `
})
export class UnauthorizedComponent {}
